/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Relationship/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import PermittedToSeeInfo from './PermittedToSeeInfo/index'
import React from 'react'
import Relationships from './Relationships/index'
import Roles from './Roles/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Relationship({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Relations/AddRelation/Search/Content/Profiles/Content/Profile/AddPersonRelation/Content/Relationship"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsNeutral800 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.800'
        })
  return (<React.Fragment
>
<div
  data-testid="Relationship.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-Z72G2P': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--ml-2-Z72G2P': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--mr-3-Z72G2P': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h4"
 color={dtColorsNeutral800}
 text="Relationship"
/>
</div>
<div
  data-testid="Relationship.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<Relationships
  viewPath={`${viewPath}/Relationships`}
/>
<Roles
  viewPath={`${viewPath}/Roles`}
/>
</div>
<PermittedToSeeInfo
  viewPath={`${viewPath}/PermittedToSeeInfo`}
/>
{children}
</React.Fragment>)
}